import { Component } from "react";
import InputGroup from "./InputGroup";
import Typeahead from "./Typeahead";
import { handleFormikValueChange } from "../../utils";

type OwnProps = {
  name?: string;
  handleChange?: $TSFixMeFunction;
  disabled?: boolean;
  isSubmitting?: boolean;
  labelKey?: string;
  values?: $TSFixMe;
  renderOption?: $TSFixMeFunction;
  renderSelectedOption?: $TSFixMeFunction;
  onChange?: $TSFixMeFunction;
};

const defaultProps: Partial<OwnProps> = {
  labelKey: "name",
};

type Props = OwnProps & typeof defaultProps;

class TypeaheadBox extends Component<Props> {
  static readonly defaultProps = defaultProps;

  constructor() {
    // @ts-expect-error TS(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    /* istanbul ignore next */
    this.handleOnChange = this.handleOnChange.bind(this);
    this.renderOption = this.renderOption.bind(this);
  }

  handleOnChange(value: $TSFixMe) {
    const { onChange } = this.props;
    if (onChange) {
      onChange(value);
    } else {
      handleFormikValueChange(this.props, value);
    }
  }

  getByPath(values: $TSFixMe, path: $TSFixMe) {
    if (!values || !path || typeof path !== "string") return undefined;

    return path.split(".").reduce((acc, key) => acc?.[key], values);
  }

  renderOption(option: $TSFixMe) {
    const { labelKey } = this.props;
    const verified =
      option.tenantName && option.tenantPublic ? (
        <span className="select-option-icon">
          <span className="icon icon3-eh-radio-button-checked" />
        </span>
      ) : null;
    const tenant =
      option.tenantName && !option.tenantPublic
        ? ` (${option.tenantName})`
        : null;
    return (
      <div>
        {/* @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type. */}
        <span className="select-option-value">{option[labelKey]}</span>
        {tenant}
        {verified}
      </div>
    );
  }

  render() {
    const {
      name,
      values,
      disabled,
      isSubmitting,
      renderOption,
      renderSelectedOption,
    } = this.props;
    return (
      <InputGroup {...this.props}>
        <Typeahead
          {...this.props}
          disabled={disabled || isSubmitting}
          onChange={this.handleOnChange}
          selectedOption={this.getByPath(values, name)}
          renderOption={renderOption || this.renderOption}
          renderSelectedOption={renderSelectedOption || this.renderOption}
        />
      </InputGroup>
    );
  }
}

export default TypeaheadBox;
